import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS CSS

export const initAnimation = function() {
  console.log('🚀🚀🚀 ANIMATION MODULE RUNNING 🚀🚀🚀');
  
  AOS.init();

};